<template>
    <div class="flex flex-wrap items-center gap-3">
        <black-white-button
            v-for="option in placementOptions"
            :key="option.code" @click="selectOption(option)"
            class="w-[84px] text-sm"
        >
            {{ option.label }}
        </black-white-button>
    </div>
</template>

<script>
    import allStores from '../../stores/all';
    import BlackWhiteButton from './BlackWhiteButton.vue';

    export default {
        mixins: [allStores],

        components: {
            BlackWhiteButton,
        },

        props: {
            placement: {
                type: Object,
                required: true,
            },
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            selectedValue() {
                return this.placement.selectedValue;
            },

            /**
             * Pre-format the list of options.
             */
            swatchOptions() {
                return this.customizerStore.sortOptions(this.placement, this.selectedValue);
            },

            placementOptions() {
                return this.swatchOptions.map((o) => ({
                    label: o.label,
                    code: o.value,
                    selected: o.selected,
                }));
            },
        },

        methods: {
            selectOption(option) {
                this.customizerStore.setSelection(this.placement.code, option.code, false);
            },
        },
    };
</script>
